import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-decision-column-molecule',
  templateUrl: './decision-column-molecule.component.html',
  styleUrls: ['./decision-column-molecule.component.scss']
})
export class DecisionColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Output() popupClicked = new EventEmitter<{}>();

  handlePOPUP(fieldData, header) {
    this.popupClicked.emit({ header, fieldData });
  }
}
